import { OnDestroy, QueryList, ViewChildren, Directive } from '@angular/core';
import {
  MiqBehaviors,
  MiqRegisteredBehaviorType,
  MiqSavable,
  MiqValidatable,
  validateElements,
} from '@shared/behaviors';

/**
 * Base implementation to abstract common adapters to relief those components
 * that were charged whit this logic but not necessary is a matter for them
 */
@Directive()
export class SavableValidatableDecorator implements MiqValidatable, MiqSavable, OnDestroy {
  @ViewChildren(MiqBehaviors) protected elementsToValidate: QueryList<MiqBehaviors>;

  protected get savableElements(): MiqSavable[] {
    return this.elementsToValidate.toArray().ofType<MiqSavable>(MiqRegisteredBehaviorType.Savable);
  }

  protected get validatableElements(): MiqValidatable[] {
    return this.elementsToValidate.toArray().ofType<MiqValidatable>(MiqRegisteredBehaviorType.Validatable);
  }

  ngOnDestroy(): void {
    this.elementsToValidate = null;
  }

  /**
   * Command chain to validate deeper validatables components
   */
  isValid(): boolean {
    return validateElements(this.validatableElements);
  }

  /**
   * Command chain to execute beforeSave on deeper component implementations
   */
  beforeSave(): void {
    this.savableElements.forEach(element => element.beforeSave());
  }

  /**
   * * Command chain to execute afterSave on deeper component implementations
   */
  afterSave(): void {
    this.savableElements.forEach(element => element.afterSave());
  }
}
